import { DriveFile, OrganizationMember, Prisma } from '@prisma/client'
import { Api } from '~/core/trpc'

type CreateOneFileArgs = Omit<
  Prisma.DriveFileCreateArgs['data'],
  'organizationId' | 'organizationMemberId'
> & {
  organizationId?: string
  organizationMemberId?: string
}

type Props = { organizationMember: OrganizationMember }

export const useSdk = ({ organizationMember }: Props) => {
  const findOneDriveFileAction = Api.dataConnector.actionRun.useMutation()
  const updateOneDriveFileAction = Api.dataConnector.actionRun.useMutation()
  const deleteDriveFileMutation = Api.dataConnector.actionRun.useMutation()
  const createOneFileMutation = Api.dataConnector.actionRun.useMutation()

  const body = {
    organizationMemberId: organizationMember?.id,
    providerKey: 'driveFile',
  }

  async function findOneFile(args: {
    driveFileId: string
  }): Promise<DriveFile> {
    const { response } = await findOneDriveFileAction.mutateAsync({
      ...body,
      providerActionKey: 'findOneDriveFile',
      args: args,
    })

    return response.driveFile
  }

  async function updateOneFile(args: {
    driveFile: Partial<DriveFile>
  }): Promise<DriveFile> {
    const { response } = await updateOneDriveFileAction.mutateAsync({
      ...body,
      providerActionKey: 'updateDriveFile',
      args: args.driveFile,
    })

    return response.driveFile
  }

  const deleteOneFile = async (args: { driveFileId: string }) => {
    const { response } = await deleteDriveFileMutation.mutateAsync({
      ...body,
      providerActionKey: 'deleteDriveFile',
      args,
    })

    return response
  }

  const createOneFile = async (args: CreateOneFileArgs): Promise<DriveFile> => {
    const { response } = await createOneFileMutation.mutateAsync({
      ...body,
      providerActionKey: 'createDriveFile',
      args,
    })

    return response.driveFile
  }

  return {
    createOneFile,
    findOneFile,
    updateOneFile,
    deleteOneFile,
  }
}
